import type { Language } from 'containers/Studies/types/recruit';

export const DEFAULT_LANGUAGE: Language = { locale: 'en', fluency: ['native', 'fluent'] };
